const CACHE_PREFIX = "polaris.assist.available:";

function cacheUserKey(): string | null {
    const userId = localStorage.getItem("loggedInUserId") || localStorage.getItem("userId");
    return userId ? `${CACHE_PREFIX}${userId}` : null;
}

export function readCachedAssistAccess(): boolean | null {
    try {
        const key = cacheUserKey();
        if (!key) {
            return null;
        }
        const raw = sessionStorage.getItem(key);
        if (raw === "true") {
            return true;
        }
        if (raw === "false") {
            return false;
        }
    } catch {
        // Private mode or blocked storage — treat as unknown.
    }
    return null;
}

export function writeCachedAssistAccess(available: boolean): void {
    try {
        const key = cacheUserKey();
        if (!key) {
            return;
        }
        // Only persist "hidden". Caching "allowed" would flash the button after an admin hides Assist.
        if (available) {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, "false");
        }
    } catch {
        // Ignore storage failures.
    }
}

/** Clears cached Assist visibility (call on logout). */
export function clearAssistAccessCache(): void {
    try {
        const keys: string[] = [];
        for (let i = 0; i < sessionStorage.length; i += 1) {
            const key = sessionStorage.key(i);
            if (key?.startsWith(CACHE_PREFIX)) {
                keys.push(key);
            }
        }
        keys.forEach((key) => sessionStorage.removeItem(key));
    } catch {
        // Ignore storage failures.
    }
}
